import React from 'react';
import { Helmet } from 'react-helmet';
import { Typography } from '@material-ui/core';
import { ThemeProvider, CssBaseline, createMuiTheme, responsiveFontSizes } from '@material-ui/core';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ParallaxProvider } from 'react-scroll-parallax';

import Title from "../Ziplyne-application/title";
import Mountain from "../Ziplyne-application/mountain";
import Slide from "./slide"; // need this file
import Half from "../Ziplyne-application/half";
import Video from "../Ziplyne-application/video";
import Statistics from "../Ziplyne-application/statistics";

import screenshot from "./images/ZLWD.svg";
import workday from "./images/Workday.svg";
import video from "./images/Ziplyne-on-WorkDay.webm";

import AppearingElement from "../Helper/AppearingElement";
import './main.css';

function Ziplyne_for_workday() {
    // Custom Material UI theme
    const theme = responsiveFontSizes(createMuiTheme({
        typography: {
            fontFamily: 'Lato, Roboto, sans-serif',
            subtitle1: {
                fontWeight: 600,
            }
        },
        palette: {
            background: {
                default: '#fff'
            }
        }
    }));

    const screenIsSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Helmet>
                <title>Ziplyne for Workday</title>
            </Helmet>

            <ThemeProvider theme={theme}>
                <CssBaseline>
                    <ParallaxProvider>
                        <main>
                            <Title img={workday} title="Does navigating corporate software feel like a grind? Perhaps your Workday would benefit from a Ziplyne." />
                            <div className="combined-background">
                                <Mountain
                                    small={screenIsSmall} title="Is this your Workday Experience...Reimagine The Possibilities!"
                                />
                                <AppearingElement variant="zoom-down">
                                    <Typography className="workday-endTitle" variant="h6">Perhaps it’s time to see the view from the Ziplyne!</Typography>
                                </AppearingElement>
                                <Half screenshot={screenshot} />
                                <Slide />
                            </div>
                            <Video
                                video={video} header="Ziplyne over Workday: Easy to Use…Easy to Manage!"
                            />
                            <Statistics />
                        </main>
                    </ParallaxProvider>
                </CssBaseline>
            </ThemeProvider>
        </>
    );
}

export default Ziplyne_for_workday;
